import React from 'react';
import i18next from 'i18next';

import {Spinner as MfSpinner} from '@famly/mf_feedback_spinner';
import {getSpacing, type SpacingIdentity} from 'web-app/styleguide/spacing';
import {Stack, type StackProps} from '@famly/mf_layout_stack';

interface StyledSpinnerProps {
    centered?: boolean;
    margined?: boolean;
    size?: number | SpacingIdentity;
    /**
     * Custom color prop to be used only in signin app, as the signin app has the
     * branding color as background
     */
    color?: 'white';
}

type SpinnerProps = {
    className?: string;
    size?: number | SpacingIdentity;
    ['data-e2e-id']?: string;
} & StyledSpinnerProps;

/**
 * @deprecated use the MF spinner directly by importing from '@famly/mf_feedback_spinner`
 */
const Spinner: React.FC<React.PropsWithChildren<SpinnerProps>> = ({
    size,
    centered,
    margined,
    'data-e2e-id': dataE2eId,
    color,
}) => {
    let stackProps: StackProps = {};
    if (centered) {
        stackProps = {
            justifyContent: 'center',
            width: '100%',
        };
    }
    if (margined) {
        stackProps = {
            justifyContent: 'center',
            alignItems: 'middle',
            marginY: 6,
        };
    }
    let convertedSize = typeof size === 'number' ? size : undefined;
    if (size && typeof size !== 'number') {
        convertedSize = Number(getSpacing(size));
    }
    return (
        <Stack {...stackProps}>
            <MfSpinner
                data-e2e-id={dataE2eId}
                size={convertedSize}
                aria-label={i18next.t('app.react.components.spinner.translations.json.loadingAriaLabel')}
                color={color === 'white' ? 'n0' : undefined}
            />
        </Stack>
    );
};

Spinner.defaultProps = {
    size: 32,
    centered: false,
    margined: false,
};

export default Spinner;
